// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__glq2v","dragIcon":"Choice_dragIcon__1fU_-","left":"Choice_left__3J-7R","input":"Choice_input__i69b_"};